<template>
      <b-container v-if="campaign" class="no-gutters">
            <b-col
                    lg="12"
                    class="box-shadow info-container no-gutters"
                    style="background-size: cover"
                    v-bind:style="{ backgroundImage: 'url(' + campaignBackground + ')' }">
                <div class="campaign-container-overlay">
                    <div class="info-text-container">
                        <p class="info_body mt-4">{{ campaign.name }}</p>
                        <b-button class="info_button mt-4" @click.stop="showCampaign">
                            {{ $t('campaign.donate')}}
                        </b-button>
                    </div>
                </div>
            </b-col>
      </b-container>
</template>

<script>
import FairApi from "@/modules/api";

export default {
    name: "CampaignContainer",
    data() {
      return {
          campaign: null,
          campaignBackground: null
      }
    },
    props: {
        campaignId: {
            type: Number,
            default: -1
        }
    },
    mounted() {
        this.fetchCampaign()
    },
    methods: {
        showCampaign() {
            this.$router.push({name: 'campaign-info-view', params: {id: this.campaignId}})
        },

        fetchCampaign: function () {
            this.loading = true
            FairApi.get(FairApi.campaign(this.campaignId), this.fetchCampaignSuccess, this.fetchCampaignFailed)
        },

        fetchCampaignSuccess: function (response) {
            this.campaign = response
            this.loading = false
            this.fetchBackgroundImage()
            this.setBreadcrumbs()
        },

        fetchCampaignFailed: function () {
            this.loading = false
            this.showAlert(this.$t('common.fetch_failed'))
        },

        fetchBackgroundImage() {
            if (this.campaign.photo) {
                FairApi.get(FairApi.photo(this.campaign.photo.id), this.success, function () {
                })
            }
        },

        success(response) {
            this.campaignBackground = response
        },
    }
}
</script>

<style scoped>

</style>